/**
 * Client sleep statistics — composed from the generic read layer (no
 * dedicated endpoint): one daily timeseries for the chart + phase split, one
 * two-period aggregate for averages, sample sizes and the Δ vs the previous
 * period. Mapped to `UiSleepStatistics` here so the screen never sees Api types.
 */
import { MetricAggregation } from '@mfw/common';

import type { FetchSleepStatisticsArgs } from './types/stats.types';

import {
  mapSleepStatisticsFromApi,
  SLEEP_AGGREGATE_KEYS,
  SLEEP_NIGHTLY_KEYS,
} from './mappers/sleepStats.mappers';
import { fetchTimeseries, fetchAggregate } from './statsQuery.api';

export const fetchSleepStatistics = async (args: FetchSleepStatisticsArgs) => {
  const [timeseries, aggregate] = await Promise.all([
    fetchTimeseries({
      clientId: args.clientId,
      fn: MetricAggregation.AVG,
      from: args.chart.from,
      granularity: 'day',
      metricKeys: SLEEP_NIGHTLY_KEYS,
      to: args.chart.to,
    }),
    fetchAggregate({
      clientId: args.clientId,
      fns: [MetricAggregation.AVG],
      metricKeys: SLEEP_AGGREGATE_KEYS,
      ranges: [args.previous, args.current],
    }),
  ]);
  return mapSleepStatisticsFromApi({ aggregate, args, timeseries });
};
